'use client'
import { useContext } from 'react'
import { UserContext } from '@/contexts/user-context'
import { useUser } from '@/contexts/user-context-v2'

export function useContextSwitcher() {
  // Detect if we're in the App Router environment (naively)
  let isAppRouter = false;
  try {
    require('next/navigation'); // throws in Pages Router
    isAppRouter = true;
  } catch {
    isAppRouter = false;
  }
  
  if (isAppRouter) {
    const { user } = useUser()
    if (user) return user
  }

  const userHook = useContext(UserContext)
  return userHook?.user
}
